/*
 *   File : text-input.js
 *   Author : https://evoqins.com
 *   Description : Text input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo, useEffect, useRef, useState } from "react";

// Component
import { Icon } from "../Icon";

//custom style
import styles from "../../Style/Component/input.module.scss";


const CustomTextInput = (props) => {

    const inputRef = useRef(null);
    const [inputValue, setInputValue] = useState(props.value);
    const [isInputFocused, setIsInputFocused] = useState(props.autoFocus || false);
    const [floatingLabel, setFloatingLabel] = useState(false);

    useEffect(() => {
        setInputValue(props.value || "");
        if (props.value) {
            setFloatingLabel(true);
        }

        // Setting to initial when we clear input value 
        if (inputValue && props.value === "") {
            setFloatingLabel(false);
        }

        if (props.isOpen === false) { // for dropdown
            setIsInputFocused(false);
            if (!props.value) {
                setFloatingLabel(false);
            }
        }

    }, [props.value, props.isOpen]);

    useEffect(() => {
        if (props.autoFocus) {
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.focus();
                }
            }, 500);
        }
    }, [props.autoFocus]);

    const _handleFocus = (e) => {

        if (isInputFocused === false) {
            setIsInputFocused(true);
            setFloatingLabel(true);
            inputRef.current.focus();
        };
    };

    const _handleBlur = (e) => {

        if (props.dropdown) {
            if (props.isOpen === false) {
                setIsInputFocused(false);
                if (inputValue === "") {
                    setFloatingLabel(false);
                }
            }
        } else {
            setIsInputFocused(false);
            if (inputValue === "") {
                setFloatingLabel(false);
            }
        }

    };

    //input handle change
    const _handleChange = (e) => {

        let value = e.target.value;

        if (props.style === "date") {

            const ALLOWED_VALUES = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""];

            if (value.length === 2 || value.length === 5) {
                value = value + "-";

            } else if (value.length === 6 || value.length === 3) {
                value = value.slice(0, -1) + "-" + value.at(-1);
            };

            if (ALLOWED_VALUES.includes(value.slice(-1)) == true) {

                setInputValue(value);
                props.handleChange(value);
            } else if ((value.at(-1) === "-" && value.at(-2) === "-") === false && value.length <= 6) {
                setInputValue(value);
                props.handleChange(value);
            }

            return;

        };

        if (props.type === "number" || props.style === "number") {
            const ALLOWED_VALUES = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""];
            if (ALLOWED_VALUES.includes(value.slice(-1)) !== false && value.length <= props.maxLength) {
                setInputValue(value);
                props.handleChange(value);
            };
        } else {
            setInputValue(value);
            props.handleChange(value);
        };
    };

    const _preventDefaults = (e) => {
        const key_code = e.keyCode || e.which;
        let value = e.target.value;

        // prevent numbers
        if (props.style === "name") {
            if (e.key >= '0' && e.key <= '9') {
                e.preventDefault();
            }
        };

        if (key_code === 8) {

            if (props.style == "date") {
                if (value.length === 7 || value.length === 4 || value.length === 6 || value.length === 3) {
                    value = value.slice(0, -2);
                    setInputValue(value);
                    props.handleChange(value);
                    e.preventDefault();

                };
            }

        };

        if (props.type === "number") {

            if (key_code === 38 || key_code == 40 || key_code == 69) {
                e.preventDefault();
            };

            if (props.inputType === "pincode") {
                if (e.key === "+" || e.key === "-" || e.key === ".") {
                    e.preventDefault();
                }
            }
        }

        if (props.type === "text" && props.inputType === "alphanumeric") {
            let regex = /^[a-zA-Z0-9\s]+$/;
            if (!regex.test(e.key)) {
                e.preventDefault();
            }
        }
    };

    return (
        // <div className={props.height || "h-78"}>

        <>

            {
                props.label && props.floatingLabel === false &&
                <label className={`${props.labelStyle} e-text-dark-charcoal e-font-weight-400 e-alt-font-poppins line-height-24px e-font-14 mb-2`}>
                    {props.label}
                    {props.require && <span className='e-text-sunset-orange'>*</span>}
                </label>
            }

            <div
                className={`${props.disabled === true ? 'opacity-5 pe-none' : ''} ${props.errorMsg && 'border-red-1px '} ${props.successMsg && 'border-color-ufo-green'} ${isInputFocused ? "e-border-1px-egyptian-blue" : "e-border-1px-sonic-silver"}  ${props.wrapperClassName} ${props.floatingLabel === false ? "mb-3" : ""} d-flex align-items-center cursor-pointer position-relative ${props.inputWrapperBorderStyle || "e-border-radius-10"}`}
                onClick={props.onClick}>


                {
                    props.floatingLabel &&
                    <label className={`${props.labelStyle} ${floatingLabel ? "focused pe-none" : ""} floating-label e-text-dark-charcoal e-font-weight-400 e-alt-font-poppins line-height-24px e-font-14`} onClick={_handleFocus}>
                        {props.label}
                        {props.require && <span className='e-text-sunset-orange'>*</span>}
                    </label>
                }

                <input id={props.id}
                    className={`${styles.e_input} ${props.className} flex-fill ${props.floatingLabel === false ? "no-floating-label padding-12px-tb e-font-14-res e-font-16" : "e-font-14-res e-font-16 py-3"}  padding-12px-all-res pe-1 e-caret-color-egyptian-blue  border-0  bg-transparent  padding-12px-left border-radius-4px e-bg-white e-text-charleston-green e-font-weight-500 e-alt-font-poppins line-height-22px`}
                    ref={props.ref || inputRef}
                    // value={inputValue}
                    value={props.value}
                    maxLength={props.maxLength}
                    max={props.maxValue}
                    type={props.type}
                    required={props.required}
                    readOnly={props.readOnly}
                    placeholder={isInputFocused || props.floatingLabel == false ? props.placeholder : ""}
                    disabled={props.disabled}
                    autoComplete={props.autoComplete}
                    onWheel={() => document.activeElement.blur()}
                    onChange={_handleChange}
                    onFocus={_handleFocus}
                    onBlur={_handleBlur}
                    onKeyDown={_preventDefaults}
                />

                {
                    props.dropdown == true &&
                    <img src={require("../../Assets/Images/KYC/drop-down.svg").default}
                        draggable={false}
                        className={`${props.disabled && "e-pointer-events-none"} ${props.dropDownIcon ? props.dropDownIcon : 'top-50 translate-middle-y'} position-absolute end-0 me-2 me-sm-3 bg-white`}
                        alt='icon'
                        onClick={() => {
                            props.onClick();
                            _handleFocus();
                        }} />
                }

                {
                    props.icon &&
                    <Icon icon={props.icon}
                        className={`position-absolute top-50 translate-middle-y  end-0  margin-12px-right`}
                        size={16} />
                }

                {
                    props.type === 2 &&
                    <span className="me-sm-3 padding-8px-all-res">
                        <Icon icon="calendar"
                            size={"1.2rem"} />
                    </span>
                }


                {/* Error text */}
                {
                    props.errorMsg !== "" &&
                    <p className={`${props.errorMsg === "" ? "opacity-0 z-index-neg-1" : "opacity-100"} mb-0 e-error-message e-font-12 line-height-12px position-absolute  top-100 start-0 padding-2-top`}>
                        {props.errorMsg}
                    </p>
                }


                {/* success text  */}
                {
                    props.successMsg !== "" &&
                    <p className={`${props.successMsg === "" ? "opacity-0 z-index-neg-1" : "opacity-100"}  mb-0 e-text-ufo-green e-font-weight-400 e-font-12 position-absolute  top-100 start-0`}>
                        {props.successMsg}
                    </p>
                }

            </div>

        </>


        // </div>
    )
}

CustomTextInput.defaultProps = {
    className: null,
    id: null,
    label: null,
    maxLength: 1000,
    handleChange: () => { },
    floatingLabel: false
}

export default memo(CustomTextInput);